/**
 * @generated SignedSource<<605859aa6e546f4eb20a6e888294a2f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReferralInvitesQuery$variables = {};
export type ReferralInvitesQuery$data = {
  readonly referralInvites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly inviteType: string;
        readonly label: string;
        readonly token: string;
      };
    }>;
  } | null;
  readonly userData: {
    readonly currency: {
      readonly currencySymbol: string;
    };
  } | null;
};
export type ReferralInvitesQuery = {
  variables: ReferralInvitesQuery$variables;
  response: ReferralInvitesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inviteType",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencySymbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferralInvitesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralInviteConnection",
        "kind": "LinkedField",
        "name": "referralInvites",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReferralInviteEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReferralInvite",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReferralInvitesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralInviteConnection",
        "kind": "LinkedField",
        "name": "referralInvites",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReferralInviteEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReferralInvite",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d5a15f28b953618fd7a2f4b511effab0",
    "id": null,
    "metadata": {},
    "name": "ReferralInvitesQuery",
    "operationKind": "query",
    "text": "query ReferralInvitesQuery {\n  referralInvites {\n    edges {\n      node {\n        inviteType\n        label\n        token\n        id\n      }\n    }\n  }\n  userData {\n    currency {\n      currencySymbol\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb37e9408363138ab4e25261029cf945";

export default node;
